import React from 'react';
import {Button, InfoMedia, List, SecSubTitle, SecTitle} from '../../components';

const AboutSevenZakta = ({data,reverse=false}) => (
    <div className="background-image" style={{backgroundImage: 'url(images/bg/about-bg-1-1.jpg)'}}>
        <div className="container container-style1">
            <div className={`row flex-row${reverse ? "" : "-reverse"} align-items-center justify-content-center gx-70`}>
                <div className={`col-lg-${data?.isWide ? "4" : "6"} d-flex align-items-center justify-content-center`}>
                    <img style={{width:'80%'}} src={data.image} alt="aboutthumb"/>
                </div>
                <div className={`col-lg-${data?.isWide ? "12" : "6"} col-xl-auto`}>
                    <div style={{maxWidth:data?.isWide ? 'none' : 500}} className="about-box2">
                        <SecTitle className="text-capitalize h1">{data?.title}</SecTitle>
                        <p>
                            {data?.desc1}
                            <List className="mt-4 list-styleBV">
                                {data?.point?.map((o,index) => <List.Item><i className="far fa-check-circle"/> {o}</List.Item>)}
                            </List>
                            {data?.desc2}
                        </p>

                    </div>
                </div>
            </div>
        </div>
    </div>
);

export default AboutSevenZakta;